var _defs, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.71,8C27.08,6.87,26.39,6.67,25,6.59s-4.92-.14-8-.14-6.58,0-8,.14S6.93,6.87,6.29,8s-1,3.07-1,6.5h0c0,3.4.34,5.36,1,6.48S7.62,22.32,9,22.42s4.92.13,8,.13,6.58-.05,8-.13,2.1-.3,2.73-1.43,1-3.08,1-6.48h0c0-3.43-.34-5.37-1-6.5ZM14.07,18.89V10.11l7.32,4.39Zm0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.4a098e11a55fcc4a7378fe327615ec74.svg";
export { ForwardRef as ReactComponent };